<template>
    <tbody>
        <tr v-if="data.length" v-for="(row, rowIndex) in data" :id="namespace + 'RowColumn' + rowIndex" v-bind:style="getTrStyleObject(rowIndex)" v-on:click="accountLevelUrl(row)">
        <template v-for="(column, columnIndex) in columns">
            <template v-if="column.visible">
                <template v-if="column.isMetricValue">
                    <template v-for="metric in row.node.metrics">
                        <td v-if="isShow(column.field)"
                            :data-label="column.label"
                            :id="namespace + 'BodyColumn' + rowIndex + columnIndex"
                            v-bind:class="getColumnClasses(column.field, rowIndex, metric.style)"
                            v-bind:style="{'min-width': column.width}">

                            {{ metric[column.field] | format(column.format) }}

                        </td>
                    </template>
                </template>

                <template v-else>
                    <td v-if="isShow(column.field)"
                        :data-label="column.label"
                        :id="namespace + 'BodyColumn' + rowIndex + columnIndex"
                        v-bind:class="getColumnClasses(column.field, rowIndex)"
                        v-bind:style="{'min-width': column.width}">

                        {{ (column.isMetricValue ? row.node.metrics[0][column.field] : row.node[column.field]) | format(column.format) }}

                    </td>
                </template>
            </template>

        </template>
    </tr>
    </tbody>
</template>

<script>
    import '@/style/reports/base_table_style.scss';

    import fixTableMixin from '@/components/reports/mixins/fixTableMixin';
    import sortTableMixin from '@/components/reports/mixins/sortTableMixin';
    import hoverTableMixin from '@/components/reports/mixins/hoverTableMixin';
    import filterMixin from '@/components/mixins/filterMixin';
    import BaseReportFiltersMixin from '@/components/mixins/baseReportFiltersMixin';

    export default {
        name: "table-body",
        components: {

        },
        props: {
            data: {
                type: Array,
                required: true
            },
            columns: {
                type: Array,
                required: true
            },
            namespace: {
                type: String,
                required: true
            }
        },
        mixins: [
            fixTableMixin,
            sortTableMixin,
            hoverTableMixin,
            filterMixin,
            BaseReportFiltersMixin
        ],
        data(){
            return {

            }
        },
        computed: {
        },
        methods: {
            isShow: function(columnName){
                return !(this.isColumnFixed(columnName) && this.isAnyFixedColumnsExist);
            },
            getColumnClasses(columnName, rowIndex, fieldStyle = ''){
                return {
                    'hovered': this.isColumnHovered(columnName),
                    'alter': (this.isColumnHovered(columnName) && rowIndex % 2 === 0),
                    'hidden': (this.isColumnFixed(columnName) && this.isAnyFixedColumnsExist),
                    'warning': columnName === 'countAccounts' && fieldStyle === 'warning',
                };
            },
            getTrStyleObject: function(rowIndex)
            {
                let styleObj = {};

                let rowRef = document.querySelector('#' + this.namespace + 'fixedRowColumn' + rowIndex);

                if (rowRef != undefined)
                {
                    styleObj.height = rowRef.offsetHeight + 'px';
                }

                if (!this.isAccountLevel()) {
                    styleObj.cursor = 'pointer';
                }

                return styleObj;
            },
            getDates() {
                let row = this.data[0];
                let metrics = row.node.metrics;
                return metrics.map(item => item.date);
            },
            isAccountLevel() {
                let currentFilters = this.$store.getters[this.namespace + '/getFilters'];

                for (let ii=0; ii<currentFilters.reportColumns.length; ii++) {
                    let selectedColumn = currentFilters.reportColumns[ii];

                    if (selectedColumn.field === 'accountName') {
                        return true;
                    }
                }

                return false;
            },
            accountLevelUrl(row) {

                let filters = {};

                if (this.getFilterData('dateRange')) {
                    filters.dateRange = this.getFilterData('dateRange');
                }

                if (row.node && row.node.partnerId) {
                    filters.partnerId = [row.node.partnerId];
                }

                if (row.node && row.node.type) {
                    filters.tableTypeName = [row.node.type];
                }

                let reportColumns = [
                    {
                        field: 'partnerName',
                        checked: true,
                        visible: true,
                    },
                    {
                        field: 'type',
                        checked: true,
                        visible: true,
                    },
                    {
                        field: 'accountName',
                        checked: true,
                        visible: true,
                    }
                ];

                let currentFilters = this.$store.getters[this.namespace + '/getFilters'];

                for (let i=0; i<this.columns.length; i++) {
                    let column = this.columns[i];

                    if (!column.isMetricValue) {
                        continue;
                    }

                    for (let ii=0; ii<currentFilters.reportColumns.length; ii++) {
                        let selectedColumn = currentFilters.reportColumns[ii];

                        if (selectedColumn.field === 'accountName') {
                            return '';
                        }

                        if (column.field === selectedColumn.field && selectedColumn.field !== 'accountName' && selectedColumn.field !== 'countAccounts') {
                            reportColumns.push({
                                field: column.field,
                                checked: column.checked,
                                visible: column.visible,
                            });
                            break;
                        }
                    }
                }

                let url = '/rawDataPartnersReport?filters=' + JSON.stringify(filters) + '&reportColumns=' + JSON.stringify(reportColumns);

                document.location.href = url;

                return '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    tbody > tr {
        text-align: left;

        &:hover {
            background: #f5f5f5;
        }

        & > * {
            font-size: 13px;
        }

        & > td {
            border-right: 1px solid #f3f3f3;
            padding: 5px;
        }

        & > td.hovered {
            background: #f5f5f5;

            &.alter{
                background: #eef1f4;
            }
        }

        & > td.hidden {
            display: none;
        }

        & > td.warning {
            color: orange;
        }

        & > td:last-child {
            border: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/reports/rawDataPartnersReport/templates/customTableBody.vue